export const CONTRACTS = {
  REVENUE_SHARE: 'revenue_share',
  FEE: 'fee',
} as const;
export type CONTRACTS = (typeof CONTRACTS)[keyof typeof CONTRACTS];
